export const cardStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '8px 12px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.divider}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const cardTopRowStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px',
};

export const fieldNameStyles = {
  color: 'text.primary',
  flex: 1,
  wordBreak: 'break-word',
};

const badgeBaseStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '2px 8px',
  borderRadius: '4px',
  whiteSpace: 'nowrap',
};

export const getBadgeStyles = badgeConfig => ({
  ...badgeBaseStyles,
  color: badgeConfig.color,
  backgroundColor: badgeConfig.backgroundColor,
});

export const valueDiffRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
};

export const currentValueStyles = {
  color: 'error.main',
  textDecoration: 'line-through',
  wordBreak: 'break-word',
};

export const arrowStyles = {
  color: 'text.secondary',
};

export const incomingValueStyles = {
  color: 'success.main',
  wordBreak: 'break-word',
};
